var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToSendStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8997 14.4998L14.3997 10.9998M14.3997 10.9998L10.8997 7.49984M14.3997 10.9998H1.56641M1.56641 5.45586V5.40006C1.56641 4.09328 1.56641 3.43939 1.82072 2.94027C2.04443 2.50122 2.40112 2.14453 2.84017 1.92082C3.3393 1.6665 3.99318 1.6665 5.29997 1.6665H16.5C17.8068 1.6665 18.4592 1.6665 18.9584 1.92082C19.3974 2.14453 19.7553 2.50122 19.979 2.94027C20.2331 3.43891 20.2331 4.092 20.2331 5.39623V16.604C20.2331 17.9082 20.2331 18.5604 19.979 19.059C19.7553 19.4981 19.3974 19.8554 18.9584 20.0791C18.4597 20.3332 17.8076 20.3332 16.5033 20.3332H5.29613C3.9919 20.3332 3.33881 20.3332 2.84017 20.0791C2.40112 19.8554 2.04443 19.4977 1.82072 19.0587C1.56641 18.5596 1.56641 17.9066 1.56641 16.5998V16.5415",
    stroke: "#AF976E",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToSendStatus);
export default __webpack_public_path__ + "static/media/to_send_status.cdc140325a24e8777ac455439fe9bd58.svg";
export { ForwardRef as ReactComponent };